import React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { useHistory } from 'react-router';
import Drawer from '@mui/material/Drawer';
import ImageIcon from '@mui/icons-material/Image';
import UserIcon from '@mui/icons-material/Person';
import ListItem from '@mui/material/ListItem';
import PeopleIcon from '@mui/icons-material/People';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import MoneyIcon from '@mui/icons-material/MonetizationOn';
import DescriptionIcon from '@mui/icons-material/Description';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';

const drawerWidth = 230;
const usersRoute = '/dashboard/users';
const eventsRoute = '/dashboard/events';
const reportsRoute = '/dashboard/reports';
const galleryRoute = '/dashboard/gallery-photos';
const donationsRoute = '/dashboard/general-donations';
const blogPostsRoute = '/dashboard/blog-posts';
const volunteersRoute = '/dashboard/volunteers';
const sponsoredKidsRoute = '/dashboard/sponsored-kids';
const sponsoredKidsDonationsRoute = '/dashboard/donations-sponsored-kids';

const classes = {
  drawer: {
    zIndex: '500',
    width: drawerWidth,
    flexShrink: 0,
    [`& .MuiDrawer-paper`]: {
      width: drawerWidth,
      boxSizing: 'border-box',
      paddingTop: '70px',
    },
  },
  activeIconColor: {
    color: '#fff',
  },
  activeMenuColor: {
    backgroundColor: '#B40404',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#B40404',
      color: '#fff',
    },
  },
};

const DashboardSideMenu = () => {
  const history = useHistory();

  return (
    <Drawer variant="permanent" sx={classes.drawer}>
      <Box>
        <List>
          {/* USERS */}
          <ListItem
            sx={
              history.location.pathname === usersRoute
                ? classes.activeMenuColor
                : ''
            }
            button
            onClick={() => history.push(usersRoute)}
          >
            <ListItemIcon>
              <UserIcon
                sx={
                  history.location.pathname === usersRoute
                    ? classes.activeIconColor
                    : ''
                }
              />
            </ListItemIcon>
            <ListItemText primary="Users" />
          </ListItem>
          {/* DONATIONS */}
          <ListItem
            sx={
              history.location.pathname.includes(donationsRoute)
                ? classes.activeMenuColor
                : ''
            }
            button
            onClick={() => history.push(donationsRoute)}
          >
            <ListItemIcon>
              <MoneyIcon
                sx={
                  history.location.pathname.includes(donationsRoute)
                    ? classes.activeIconColor
                    : ''
                }
              />
            </ListItemIcon>
            <ListItemText primary="General Donations" />
          </ListItem>
          {/* GALLERY */}
          <ListItem
            sx={
              history.location.pathname.includes(galleryRoute)
                ? classes.activeMenuColor
                : ''
            }
            button
            onClick={() => history.push(galleryRoute)}
          >
            <ListItemIcon>
              <ImageIcon
                sx={
                  history.location.pathname.includes(galleryRoute)
                    ? classes.activeIconColor
                    : ''
                }
              />
            </ListItemIcon>
            <ListItemText primary="Gallery Photos" />
          </ListItem>
          {/* EVENTS */}
          <ListItem
            sx={
              history.location.pathname.includes(eventsRoute)
                ? classes.activeMenuColor
                : ''
            }
            button
            onClick={() => history.push(eventsRoute)}
          >
            <ListItemIcon>
              <EventNoteIcon
                sx={
                  history.location.pathname.includes(eventsRoute)
                    ? classes.activeIconColor
                    : ''
                }
              />
            </ListItemIcon>
            <ListItemText primary="Events" />
          </ListItem>
          {/* VOLUNTEERS */}
          <ListItem
            sx={
              history.location.pathname.includes(volunteersRoute)
                ? classes.activeMenuColor
                : ''
            }
            button
            onClick={() => history.push(volunteersRoute)}
          >
            <ListItemIcon>
              <PeopleIcon
                sx={
                  history.location.pathname.includes(volunteersRoute)
                    ? classes.activeIconColor
                    : ''
                }
              />
            </ListItemIcon>
            <ListItemText primary="Volunteers" />
          </ListItem>
          {/* SPONSORED KIDS */}
          <ListItem
            sx={
              history.location.pathname.includes(sponsoredKidsRoute)
                ? classes.activeMenuColor
                : ''
            }
            button
            onClick={() => history.push(sponsoredKidsRoute)}
          >
            <ListItemIcon>
              <EmojiPeopleIcon
                sx={
                  history.location.pathname.includes(sponsoredKidsRoute)
                    ? classes.activeIconColor
                    : ''
                }
              />
            </ListItemIcon>
            <ListItemText primary="Sponsored Kids" />
          </ListItem>
          {/* SPONSORED KIDS DONATIONS */}
          <ListItem
            sx={
              history.location.pathname.includes(sponsoredKidsDonationsRoute)
                ? classes.activeMenuColor
                : ''
            }
            button
            onClick={() => history.push(sponsoredKidsDonationsRoute)}
          >
            <ListItemIcon>
              <VolunteerActivismIcon
                sx={
                  history.location.pathname.includes(
                    sponsoredKidsDonationsRoute
                  )
                    ? classes.activeIconColor
                    : ''
                }
              />
            </ListItemIcon>
            <ListItemText primary="Sponsored Kids Donations" />
          </ListItem>
          {/* REPORTS */}
          <ListItem
            sx={
              history.location.pathname.includes(reportsRoute)
                ? classes.activeMenuColor
                : ''
            }
            button
            onClick={() => history.push(reportsRoute)}
          >
            <ListItemIcon>
              <DescriptionIcon
                sx={
                  history.location.pathname.includes(reportsRoute)
                    ? classes.activeIconColor
                    : ''
                }
              />
            </ListItemIcon>
            <ListItemText primary="Reports" />
          </ListItem>
          {/* BLOG POSTS */}
          <ListItem
            sx={
              history.location.pathname.includes(blogPostsRoute)
                ? classes.activeMenuColor
                : ''
            }
            button
            onClick={() => history.push(blogPostsRoute)}
          >
            <ListItemIcon>
              <LocalLibraryIcon
                sx={
                  history.location.pathname.includes(blogPostsRoute)
                    ? classes.activeIconColor
                    : ''
                }
              />
            </ListItemIcon>
            <ListItemText primary="Blog Posts" />
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );
};

export default DashboardSideMenu;
